import { render } from "./UsuarioResumenEstadisticasFacturacion.vue?vue&type=template&id=16ad559e"
import script from "./UsuarioResumenEstadisticasFacturacion.vue?vue&type=script&lang=js"
export * from "./UsuarioResumenEstadisticasFacturacion.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__